import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "SystemTeaser",
    component: () => (__SERVER__ ? require("./system-teaser-view") : import("./system-teaser-view"))
});

export default definition;
